import { call, put, takeEvery } from 'redux-saga/effects';
import api from '../../externals/costViewProxy';
import vendorsApi from '../../externals/vendorProxy';
import {
  REQUEST_COST_VIEW_DATA,
  receiveCostViewData,
  REQUEST_COST_VIEW_DETAILED_DATA,
  receiveCostViewDetailedData,
  REQUEST_WAREHOUSES_AND_OPCOS
} from '../actions/costViewActions';
import { receiveAllOpcos, receiveWarehouses } from '../actions/vendorActions';

import {
  receiveErrorInCostViewDataFetch,
  receiveErrorInCostViewDetailedDataFetch,
  receiveErrorInWarehouseAndOpcoFetch
} from '../actions/errorDialogActions';
import {
  UNABLE_TO_LOAD_COST_VIEW_DATA,
  UNABLE_TO_LOAD_COST_VIEW_DETAILED_DATA,
  UNABLE_TO_LOAD_WAREHOUSES_AND_OPCOS
} from '../../helpers/messageConstant';
/**
 * Cost View Saga: will be fired on cost view related actions and will call respective APIs and dispatch success/failure actions based on API response
 *
 * @author slak4170
 */

export function* requestCostViewData({ data }) {
  try {
    const costViewData = yield call(api.fetchCostViewDataRecords, data);
    yield put(receiveCostViewData(costViewData));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_LOAD_COST_VIEW_DATA;
    yield put(receiveErrorInCostViewDataFetch(errorMessage));
  }
}

export function* requestCostViewDetailedData({ data }) {
  try {
    const costViewDetailedData = yield call(api.fetchCostViewDataDetailRecords, data);
    yield put(receiveCostViewDetailedData(costViewDetailedData));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_LOAD_COST_VIEW_DETAILED_DATA;
    yield put(receiveErrorInCostViewDetailedDataFetch(errorMessage));
  }
}

export function* fetchWarehousesAndOpcos({ data }) {
  try {
    const warehouses = yield call(vendorsApi.fetchWarehouses, data);
    const opcos = yield call(vendorsApi.fetchAllOpcos);
    yield put(receiveWarehouses(warehouses));
    yield put(receiveAllOpcos(opcos));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_LOAD_WAREHOUSES_AND_OPCOS;
    yield put(receiveErrorInWarehouseAndOpcoFetch(errorMessage));
  }
}

export function* costViewSaga() {
  yield takeEvery(REQUEST_COST_VIEW_DATA, requestCostViewData);
  yield takeEvery(REQUEST_COST_VIEW_DETAILED_DATA, requestCostViewDetailedData);
  yield takeEvery(REQUEST_WAREHOUSES_AND_OPCOS, fetchWarehousesAndOpcos);
}
